export default {
  SET_CAST_STATUS(state, value) {
    state.isCastRunning = value;
  },
  SET_RUNNING_CAST_BOARD_NAME(state, value) {
    state.castRunningBoardsName.push(value);
  },
  REMOVE_RUNNING_CAST_BOARD_NAME(state, value) {
    state.castRunningBoardsName.pop(value);
  },
  SET_CAST_INSTALLED_BOARD_NAME(state, value) {
    state.castInstalledBoardsName.push(value);
  },
  OPEN_JOIN_CAST_POPUP(state, value) {
    state.joinCastPopup = value;
  },
  OPEN_JOIN_ROOM_POPUP(state, value) {
    state.joinRoomPopup = value;
  },
  SET_BACKGROUND_LINKS(state, value) {
    state.backLinks = value;
  },
  SET_ROOM_STATUS(state, value) {
    state.isRoomRunning = value;
  },
  SET_ROOM_INSTALLED_BOARD_NAME(state, value) {
    state.roomInstalledBoardsName.push(value);
  },
  SET_RUNNING_ROOM_BOARD_NAME(state, value) {
    state.roomRunningBoardsName.push(value);
  },
  REMOVE_RUNNING_ROOM_BOARD_NAME(state, value) {
    state.roomRunningBoardsName.pop(value);
  },
};
